import { useAccount, useBalance } from 'wagmi';
import UnstakeForm from './UnstakeForm';
import { getChainConstant } from '@/domain/chain';
import { Addresses } from '@/domain/addresses';
import useUnstake from '@/application/staking/useUnstake';
import useChainId from '@/hooks/useChainId';
import useLockedUntilTimestamp from '@/application/staking/useLockedUntilTimestamp';
import { Dispatch, SetStateAction } from 'react';
import { LockPeriod } from '@/domain/stake';
import useFloorMarketPrice from '@/application/token/useFloorTokenPrice';

const UnstakeFormContainer = () => {
  const { data: floorTokenPrice } = useFloorMarketPrice();
  const { address, isConnected } = useAccount();

  const chainId = useChainId();
  const { data: balance } = useBalance({
    address,
    token: getChainConstant(Addresses, chainId, 'VeFloorStaking'),
  });

  const { data: lockedUntil } = useLockedUntilTimestamp({
    userAddress: address,
  });

  const { unstake, isPending, isConfirming, isConfirmed, error } = useUnstake();

  const ethValue =
    floorTokenPrice &&
    balance?.value &&
    (floorTokenPrice * balance?.value) / BigInt(1e18);

  return (
    <UnstakeForm
      balance={balance?.value}
      ethValue={ethValue}
      unstake={unstake}
      isUnstakePending={isPending}
      isUnstakeConfirming={isConfirming}
      isUnstakeConfirmed={isConfirmed}
      error={error}
      isConnected={isConnected}
      lockedUntil={lockedUntil}
    />
  );
};

export default UnstakeFormContainer;
